import AdvancedSearchListCreatorLayout from './AdvancedSearchListCreatorLayout';
import type { AdvancedSearchListCreatorPageProps } from './advancedSearchListCreatorPageTypes';
import { useAdvancedSearchListCreatorPage } from './useAdvancedSearchListCreatorPage';

export { debugAtom, searchTreeBuilderStateAtom } from './stateAtoms';
export type { AdvancedSearchListCreatorPageProps } from './advancedSearchListCreatorPageTypes';

export default function AdvancedSearchListCreatorPage({
  searchTreeBuilderTestId,
  previewSectionTestId,
  loadedTree,
  loadedMetadata,
}: AdvancedSearchListCreatorPageProps) {
  const page = useAdvancedSearchListCreatorPage({ loadedTree, loadedMetadata });

  return (
    <AdvancedSearchListCreatorLayout
      page={page}
      searchTreeBuilderTestId={searchTreeBuilderTestId}
      previewSectionTestId={previewSectionTestId}
    />
  );
}
